import React, { useState, useEffect } from "react";
import Dropdown from "./Dropdown";
import {
  Button,
  Box,
  Textarea,
  FormControl,
  FormLabel,
  FormErrorMessage,
  RadioGroup,
  Radio,
  useToast,
} from "@chakra-ui/react";

const API_BASE_URL = "https://qaapirgeneng.digitalfields.co.za/ws1.cfc";

const SendEmailMessage = ({ recipientID, HrequestID, HeventID, onMessageSent }) => {
  const [msgTemplates, setMsgTemplates] = useState([]);
  const [selectedMsgTemplate, setSelectedMsgTemplate] = useState({});
  const [errors, setErrors] = useState({
    sendMyselfEmailYN: "",
  });

  const toast = useToast();

  // Parameters neccessary for making api requests
  const HuserID = localStorage.getItem("HuserID");
  const UUID = localStorage.getItem("UUID");

  // API Requests:

  // Fetching message templates for dropdown
  const fetchMessageTemplates = async () => {
    try {
      let url = `${API_BASE_URL}?method=getMessageTemplates&huserID=${HuserID}&uuid=${UUID}&HclientID=11`;

      const response = await fetch(url, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setMsgTemplates(data);
    } catch (error) {
      console.error("Error fetching message templates", error);
    }
  };

  // Sending email / message
  const sendEmailMessage = async () => {
    try {
      let url = `${API_BASE_URL}?method=triggerEvent&huserID=${HuserID}&uuid=${UUID}&recipientID=${recipientID}&HrequestID=${HrequestID}&HeventID=${selectedMsgTemplate.HeventID}&sendToMeYN=${selectedMsgTemplate.sendMyselfEmailYN}`;

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          messageManualInput: selectedMsgTemplate.manualInput,
        }),
        mode: "no-cors",  // ← Add this line!
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      console.error("Error sending message!", error);
    } finally {
      toast({
        title: "Message Sent Successfully!",
        description: "",
        status: "success",
        duration: 6000,
        isClosable: true,
      });
      if (onMessageSent) {
        onMessageSent();
      }
    }
  };

  // Event Handlers:

  // Invoked when user selects a message template from dropdown
  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "msgTemplate") {
      const selectedOption = e.target.selectedOptions[0];
      
      // Find the selected template to get HeventID
      const selectedTemplate = msgTemplates.find(template => template.messagetemplateID == value);

      setSelectedMsgTemplate((prevState) => ({
        ...prevState,
        [name]: value,
        textInsert: selectedOption.getAttribute("data-selected"),
        HeventID: selectedTemplate ? selectedTemplate.HeventID : null,
      }));
    }

    if (name === "manualInput") {
      setSelectedMsgTemplate((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  // Send email to self checkbox selection
  const handleRadioChange = (name, value) => {
    // Update form data
    setSelectedMsgTemplate((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Clear any previous error
    if (errors.sendMyselfEmailYN) {
      setErrors({
        ...errors,
        sendMyselfEmailYN: "",
      });
    }
  };

  // Validate sendMyselfEmailYN radio input
  const validateRadio = () => {
    const newErrors = {
      sendMyselfEmailYN: "",
    };

    let isValid = true;

    if (
      selectedMsgTemplate.sendMyselfEmailYN === null ||
      !selectedMsgTemplate.sendMyselfEmailYN
    ) {
      newErrors.sendMyselfEmailYN = "Please select an option";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate radio button input group before submission
    if (!validateRadio()) {
      return;
    }

    sendEmailMessage();
  };

  useEffect(() => {
    fetchMessageTemplates();
  }, []);

  return (
    <Box onSubmit={handleSubmit} p="4" as="form">
      {/* Email message template dropdown selection */}
      <Dropdown
        width="32%"
        placeHolder="Select A Template"
        name="msgTemplate"
        options={msgTemplates}
        optionKey="messagetemplateID"
        optionDisplay="triggername"
        state={selectedMsgTemplate}
        handleChange={handleChange}
        optionDataAdd="directTextInsert"
        required={true}
        mb="8"
      />

      {/* Text area added if directTextInsert on template = 1 */}
      {!!selectedMsgTemplate.textInsert && (
        <Textarea
          onChange={handleChange}
          type="text"
          name="manualInput"
          placeholder="Manual Message Input"
          w="32%"
          minHeight="140px"
          mt="2"
          isRequired
        />
      )}

      {/* sendMyselfEmailYN checkbox input */}
      <FormControl isInvalid={!!errors.sendMyselfEmailYN} mt="12">
        <FormLabel fontWeight="bold">Send Email to Myself:</FormLabel>
        <RadioGroup
          isRequired
          name="sendMyselfEmailYN"
          onChange={(value) => handleRadioChange("sendMyselfEmailYN", value)}
        >
          <Radio value="1" mr="8">
            Yes
          </Radio>
          <Radio value="0">No</Radio>
        </RadioGroup>
        <FormErrorMessage color="secondary2">
          {errors.sendMyselfEmailYN}
        </FormErrorMessage>
      </FormControl>

      <Button type="submit" mt="6">
        Send
      </Button>
    </Box>
  );
};

export default SendEmailMessage;
